module.exports = __webpack_public_path__ + "static/media/odlwebCrawling.065f8038.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/Wickey/odlwebCrawling.jpg
// module id = 373
// module chunks = 0